@if(visible())
{
<div class="w-full pt-1 text-xs font-poppins bg-orange-300 text-orange-800 text-center border-b border-orange-200 shadow-md">
  <span class="inline-flex items-center gap-2 text-orange-900">
    <mat-icon class="text-base align-middle">info</mat-icon>
    {{ message() }}
  </span>
</div>
}